import { useEffect, useState } from 'react'
import { Container, Text, TextButton, toast } from 'react-common'
import { useTranslation } from 'react-i18next'
import { Select } from '@platform/ui'
import { ProfileApi } from '@/api/models/profile'
import { useAuth } from '@/features/auth/useAuth'
import { captureException } from '@/utils/sentryUtils'
import { useFormattedDateTime } from './hooks/useFormattedDateTime'
import { useTimezoneOptions } from './hooks/useTimezoneOptions'
import styles from './TimezoneTab.module.scss'

export const TimezoneTab = () => {
  const { t } = useTranslation()

  const { user } = useAuth()

  const [timezone, setTimezone] = useState<string>('')

  const formattedDate = useFormattedDateTime(timezone)
  const timezoneOptions = useTimezoneOptions()

  const handleTimezoneAutoClick = () => {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (browserTimezone === timezone) return

    setTimezone(browserTimezone)
    ProfileApi.setUserTimezone({ id: user!.id, timezone: browserTimezone })
      .then(() => toast.success(t('userProfile.timezoneSet')))
      .catch(captureException)
  }

  const handleTimezoneChange = (option: { label: string; value: string }) => {
    if (option.value === timezone) return

    setTimezone(option.value)
    ProfileApi.setUserTimezone({ id: user!.id, timezone: option.value })
      .then(() => toast.success(t('userProfile.timezoneSet')))
      .catch(captureException)
  }

  useEffect(() => {
    setTimezone(user?.timezone || '')
  }, [user?.timezone])

  return (
    <div className={styles.container}>
      <Container bottomPadding={Container.Padding.p18}>
        <Text.H4>{t('userProfile.currentDateAndTime')}</Text.H4>
      </Container>
      <Container bottomPadding={Container.Padding.p40}>
        <Text.Body>{formattedDate}</Text.Body>
      </Container>
      <Container bottomPadding={Container.Padding.p18}>
        <Text.H4>{t('userProfile.timezone')}</Text.H4>
      </Container>
      <Container bottomPadding={Container.Padding.p24}>
        {/* @ts-expect-error known issue */}
        <Select key={Date.now()} value={timezone} onChange={handleTimezoneChange} options={timezoneOptions} />
      </Container>
      <TextButton size="large" onClick={handleTimezoneAutoClick}>
        {t('userProfile.auto')}
      </TextButton>
    </div>
  )
}
